<template>
	<v-container fluid="fluid" calendarOverview style="max-width: 100%">
		<v-layout row wrap style="margin-bottom: 70px">
			<table-loader v-if="loading" />
			<h1 class="hidden-sm-and-down" v-if="!selectedUnit">Planner</h1>
			<v-spacer></v-spacer>
			<div class="d-inline-flex" v-if="!selectedUnit">
				<v-select
					prepend-inner-icon="directions_car"
					:items="this.selectableUnits"
					v-model="filterUnit"
					label="Filter unit"
					item-text="fullDescription"
					item-value="unitId"
					single-line
					menu-props="'bottom'"
				></v-select>
				<planner-filter
					@gotoDate="gotoDate"
					:minDate="filterMinDate"
					:maxDate="filterMaxDate"
				></planner-filter>
			</div>
			<div class="flex md12 plannerContainer">
				<v-flex
					units
					xl1
					md3
					sm3
					xs3
					text-xs-left
					id="units"
					class="active"
					v-if="!selectedUnit"
				>
					<ul class="pl-0">
						<li
							class="item"
							v-for="(item, index) in units"
							:key="index"
							@click="showUnit(item.unitId)"
						>
							<div class="content">
								<div class="header calenderUnit">
									<span class="unitDetails d-inline">
										{{ item.name }}<br />
										<small>{{ item.license }}</small>
									</span>
								</div>
							</div>
						</li>
					</ul>
				</v-flex>
				<v-flex md12 daysScroller id="daysScroller">
					<div class="daysContainer">
						<div class="dates">
							<span
								v-for="(month, index) in months"
								:key="index"
								class="monthSchedule"
							>
								<span
									class="day header"
									v-for="(day, index) in month.days"
									:key="index"
									:class="[
										checkDateIsToday(index + 1, month.month, month.year)
											? 'isToday'
											: '',
										'day_' +
											(String(index + 1) +
												String(month.month) +
												String(month.year))
									]"
									:data-ellapsedrist="
										checkDateIsToday(index + 1, month.month, month.year)
											? percTodayElapsed()
											: ''
									"
								>
									{{ getDay(index + 1, month.month, month.year) }}
									<span class="dateTag">{{ day }} - {{ month.month }}</span>
									<span
										id="elapsedIndicator"
										v-if="checkDateIsToday(index + 1, month.month, month.year)"
										:style="{ left: elapsedToday + '%' }"
									></span>
								</span>
							</span>
						</div>
						<div
							class="unitTimeline"
							v-for="(unit, index) in units"
							:key="index"
						>
							<span
								v-for="(month, index) in months"
								class="monthSchedule"
								:key="index"
							>
								<span
									class="day"
									:key="index"
									:id="
										unit.unitId +
											'_' +
											month.year +
											'_' +
											month.month +
											'_' +
											day
									"
									v-for="(day, index) in month.days"
									@click="newReservation($event, unit.unitId, month, day)"
								>
								</span>
							</span>
						</div>
					</div>
				</v-flex>
			</div>
		</v-layout>
		<v-btn
			fixed
			dark
			fab
			menu-props="bottom"
			right
			color="pink"
			@click="newReservation()"
			v-if="!selectedUnit"
		>
			<v-icon>add</v-icon>
		</v-btn>
		<user-modal
			:id="user.id"
			:edit="editUser"
			:user="user"
			ref="userModal"
			:showSelector="true"
		></user-modal>
		<reservations-modal
			:id="reservation.id"
			:edit="editReservation"
			:reservation="reservation"
			:units="units"
			ref="reservationModal"
			@update="getUnits"
			@copyReservation="copyReservation($event)"
		></reservations-modal>
		<new-reservation-modal
			:id="reservation.id"
			:edit="newReservationData"
			:units="units"
			@newUser="newUser()"
			ref="newReservationModal"
			@update="getUnits"
		></new-reservation-modal>
		<history-modal
			:units="units"
			ref="historyModal"
			@update="getUnits"
			@copyReservation="copyReservation($event)"
		></history-modal>
	</v-container>
</template>

<script>
import UserModal from '@/components/Users/UserModal';
import UnitModal from '@/components/Units/UnitModal';
import HistoryModal from '@/components/History/HistoryModal';
import NewReservationModal from '@/components/Reservations/NewReservationModal';
import PlannerFilter from '@/components/Planner/PlannerFilter';
import { _ } from 'vue-underscore';
import * as utils from '@/utils/utils';
import moment from 'moment';

export default {
	name: 'Planner',
	components: {
		UserModal,
		NewReservationModal,
		PlannerFilter,
		HistoryModal
	},
	created: function() {
		var self = this;
		this.getUnits();
		this.renderMonths();

		window.emitter.$off('newUser');
		window.emitter.$on('newUser', function() {
			self.newUser();
		});

		// window.emitter.$on('updateHistory', function() {
		//     self.getUnits();
		// });

		var self = this;
		self.elapsedToday = self.percTodayElapsed();

		this.loop = (function() {
			self.elapsedToday = self.percTodayElapsed();
		},
		60000);
	},
	destroyed() {
		clearInterval(this.loop);
	},
	props: ['selectedUnit'],
	data() {
		return {
			units: [],
			saveUnits: [],
			months: {},
			utils: utils,
			loading: false,
			filterUnit: '',
			elapsedToday: 0,
			scrolledMonth: '',
			scrolledMonthDescription: '',
			scrollIndex: 1,
			scrollTimeout: null,
			filterMinDate: '',
			filterMaxDate: '',
			showUnits: true,
			loop: null,
			reservation: {
				id: ''
			},
			editReservation: {
				showModal: false
			},
			newReservationData: {
				showModal: false,
				startDate: '',
				endDate: '',
				startTime: '00:00',
				endTime: '00:00',
				discount: 0,
				costData: {
					prices: [],
					additionalItems: []
				}
			},
			editUser: {
				showModal: false
			},
			user: {
				edit: false
			},
			unit: {
				unitId: 0
			},
			editUnit: {
				showModal: false
			},
			plannerHtml: '',
			reservationList: {}
		};
	},
	mounted() {
		let self = this;

		this.gotoToday();
	},
	beforeDestroy() {
		window.emitter.$off('updateReservations');
	},
	computed: {
		selectableUnits() {
			var list = [{ fullDescription: 'Toon alle', unitId: 'all' }];
			return list.concat(this.saveUnits);
		},
		rentOrHistoryId() {
			console.log(this.reservation);
		}
	},
	beforeDestroy() {
		window.emitter.$off('updateHistory');
	},
	watch: {
		$route(to, from) {
			var self = this;
			if (to.name === 'Planner') {
				this.gotoToday();
			}
		},
		filterUnit(newVal) {
			if (newVal !== 'all') {
				this.units = _.filter(this.saveUnits, { unitId: newVal });
			} else {
				this.units = this.saveUnits;
			}
		}
	},
	updated() {
		this.renderReservations();
	},
	methods: {
		hasReservation(key) {
			return true;
		},
		detectScroll() {
			var self = this;
			var elem = this.$el;
			var daysScroller = elem.querySelector('#daysScroller');
			var monthContainer = elem.querySelector('#month');
			var todayElement = elem.querySelector('.isToday');
			var currentMonth = moment().month();
			var month = currentMonth;
			self.scrolledMonth = currentMonth;
			todayElement.scrollIntoView({ block: 'center' });
			this.scrolledMonthDescription = this.utils.getMonth(this.scrolledMonth);
			monthContainer.innerHTML = self.utils.getMonth(currentMonth);
			daysScroller.addEventListener('scroll', function(e) {
				var scrollLeft = e.target.scrollLeft;

				Object.keys(self.months).forEach(key => {
					var monthData = self.months[key];
					if (
						scrollLeft >= monthData.scrollLeft &&
						scrollLeft <= monthData.scrollRight
					) {
						month = parseInt(key) - 1;
					}
				});

				monthContainer.innerHTML = self.utils.getMonth(month);
			});
		},
		gotoToday() {
			setTimeout(function() {
				var todayElement = document.querySelector('.isToday');
				todayElement.scrollIntoView({ inline: 'center' });
			}, 0);
		},
		getUnits() {
			this.loading = true;
			var myInit = {
				method: 'POST',
				mode: 'cors',
				body: JSON.stringify({
					b: localStorage.getItem('b')
				}),
				cache: 'default'
			};
			var self = this;
			fetch(
				basePath +
					'api/reservations/getPlannerData/' +
					(self.selectedUnit ? self.selectedUnit : ''),
				myInit
			)
				.then(function(response) {
					var contentType = response.headers.get('content-type');
					self.loading = false;
					if (contentType && contentType.includes('application/json')) {
						return response.json();
					}
					throw new TypeError("Oops, we haven't got JSON!");
				})
				.then(function(json) {
					self.units = json.data;
					self.saveUnits = self.units;
					setTimeout(function() {
						//  self.renderReservations();
					}, 500);
				})
				.catch(function(error) {
					console.log(error);
				});
		},
		renderReservations() {
			let self = this;
			const elements = document.getElementsByClassName('reservation');
			while (elements.length > 0) elements[0].remove();
			for (var i = 0; i < this.units.length; i++) {
				let unit = this.units[i];
				for (var j = 0; j < unit.rentData.length; j++) {
					let schedule = unit.rentData[j];
					for (var k = 0; k < schedule.days.length; k++) {
						let day = schedule.days[k];
						if (!this.reservationList[day['identifier']]) {
							this.reservationList[day['identifier']] = [];
						}

						this.reservationList[day['identifier']].push(day);

						let el = document.getElementById(day['identifier']);
						if (el) {
							const title =
								this.utils.getFullDate(schedule['startDate']) +
								' t/m ' +
								this.utils.getFullDate(schedule['endDate']) +
								' ' +
								schedule['firstname'] +
								' ' +
								schedule['lastname'];
							document
								.getElementById(day['identifier'])
								.insertAdjacentHTML(
									'beforeend',
									'<i slot="activator" id="reservation_' +
										day['identifier'] +
										'_' +
										schedule['id'] +
										'" title="' +
										title +
										'" class="' +
										day.class +
										(schedule.closed == '1'
											? ' closed'
											: schedule.inRent == '1'
											? ' green-tp'
											: '') +
										'" reservation" data-starttext="' +
										day.starttext +
										'" data-endtext="' +
										day.endtext +
										'" data-closed="' +
										schedule.closed +
										'" data-reservationid="' +
										schedule.id +
										'" style="left: ' +
										day.left +
										'%; right: ' +
										day.right +
										'%"></i>'
								);
							let reservationEl = document.getElementById(
								'reservation_' + day['identifier'] + '_' + schedule['id']
							);
							reservationEl.onclick = function(e) {
								let reservationId = e.srcElement.dataset.reservationid;
								let closed = e.srcElement.dataset.closed;
								self.viewReservationDetails(reservationId, closed == '1');
								e.preventDefault();
								return false;
							};
						}
					}
				}
			}
		},
		renderMonths: function() {
			let year = moment().year();
			let currentMonth = moment().month();
			let month = currentMonth;
			let monthsTemp = {};
			let visibleMonths = {};
			const width = window.innerWidth < 700 ? 100 : 200;
			let count = 0;
			const monthsBack = 3;
			const monthsForward = 6;
			let startMonth = currentMonth;

			for (
				var j = currentMonth - monthsBack;
				j <= startMonth + monthsForward;
				j++
			) {
				let loopMonth = j;

				if (loopMonth > 12) {
					loopMonth = j - 12;
				}
				if (loopMonth < 1) {
					loopMonth = j + 12;
				}
				if (loopMonth > currentMonth && count <= monthsBack) {
					visibleMonths[
						String(year - 1) + String(this.addZeroToNumber(loopMonth))
					] = {
						year: year - 1,
						month: loopMonth
					};
				} else if (loopMonth < currentMonth && count >= monthsBack) {
					visibleMonths[
						String(year + 1) + String(this.addZeroToNumber(loopMonth))
					] = {
						year: year + 1,
						month: loopMonth
					};
				} else {
					visibleMonths[
						String(year) + String(this.addZeroToNumber(loopMonth))
					] = {
						year: year,
						month: loopMonth
					};
				}

				count++;
			}
			let convertedMonths = Object.values(visibleMonths);
			for (var i = 0; i < convertedMonths.length; i++) {
				var visible = convertedMonths[i];
				var daysCount = moment(
					visible['year'] + '-' + this.getConvertedMonth(visible['month']),
					'YYYY-MM'
				).daysInMonth();

				if (i === 0) {
					this.filterMinDate =
						visible['year'] +
						'-' +
						this.addZeroToNumber(visible['month']) +
						'-' +
						'01';
				}

				if (i === convertedMonths.length - 1) {
					this.filterMaxDate =
						visible['year'] +
						'-' +
						this.addZeroToNumber(visible['month']) +
						'-' +
						daysCount;
				}

				if (!monthsTemp[i]) {
					monthsTemp[i] = {
						month: visible['month'],
						year: visible['year'],
						days: daysCount,
						scrollLeft: daysCount * width * (i + 1),
						scrollRight: daysCount * width * (i + 1),
						daysWidth: daysCount * width,
						scrollPos: 0
					};
				}
			}

			this.months = monthsTemp;
		},
		addZeroToNumber(number) {
			if (String(number).length === 1) {
				return '0' + String(number);
			} else {
				return number;
			}
		},
		getConvertedMonth: function(month) {
			return month;
		},
		getDay: function(day, month, year) {
			var dayarray = [
				'zondag',
				'maandag',
				'dinsdag',
				'woensdag',
				'donderdag',
				'vrijdag',
				'zaterdag'
			];
			var mydate = year + '-' + month + '-' + day + 'T00:00:00';
			return dayarray[moment(mydate, 'YYYY-MM-DD').day()];
		},
		checkDateIsToday: function(day, month, year) {
			var mydate = year + '-' + month + '-' + day + 'T00:00:00';
			return moment(mydate, 'YYYY-MM-DD').isSame(moment(), 'day');
		},
		percTodayElapsed(start, end) {
			var now = moment();
			start = start || moment(now).startOf('day');
			end = end || moment(now).endOf('day');
			var totalMillisInRange = end.valueOf() - start.valueOf();
			var elapsedMillis = now.valueOf() - start.valueOf();
			return Math.max(
				0,
				Math.min(100, 100 * (elapsedMillis / totalMillisInRange))
			);
		},
		getMonth: function(index) {
			if (index || index === 0) {
				var maandArray = [
					'januari',
					'februari',
					'maart',
					'april',
					'mei',
					'juni',
					'juli',
					'augustus',
					'september',
					'oktober',
					'november',
					'december'
				];
				return maandArray[index];
			} else {
				return '';
			}
		},
		checkReservedDay: function(unit, day, monthInfo) {
			var dayBlock = [];
			if (unit.rentData.length && monthInfo) {
				for (var i = 0; i < unit.rentData.length; i++) {
					var rentData = unit.rentData[i];
					var startDate = rentData.startDate;
					var endDate = rentData.endDate;
					var momentDate = moment(
						monthInfo.year + '-' + monthInfo.month + '-' + day,
						'YYYY-MM-DD'
					);

					if (momentDate.isBetween(startDate, endDate, 'days', '[]')) {
						let isSameStart = momentDate.isSame(startDate, 'day');
						let isSameEnd = momentDate.isSame(endDate, 'day');
						const startDateFormatted = moment(rentData.startDate).format(
							'DD-MM-YYYY HH:mm'
						);
						dayBlock.push({
							closed: rentData.closed == 1,
							rentId: rentData.id,
							active: rentData.inRent == 1,
							activeAfterRentPeriod:
								momentDate.isSameOrBefore(new Date()) &&
								momentDate.isSameOrAfter(moment(rentData.startDate)) &&
								moment(endDate).isSameOrBefore(momentDate)
									? true
									: false,
							startDate: startDateFormatted,
							leftstart: isSameStart
								? this.getStartLeft(startDate, momentDate)
								: '0',
							startText: isSameStart ? moment(startDate).format('HH:mm') : '',
							endText: isSameEnd ? moment(endDate).format('HH:mm') : '',
							rightstart: isSameEnd
								? this.getStartRight(endDate, momentDate)
								: '0',
							endDate: moment(rentData.endDate).format('DD-MM-YYYY HH:mm'),
							fullname: rentData.firstname + ' ' + rentData.lastname,
							startDay: isSameStart,
							endDay: isSameEnd
						});
					} else if (
						rentData.inRent == 1 &&
						momentDate.isSameOrBefore(new Date()) &&
						momentDate.isSameOrAfter(moment(rentData.startDate)) &&
						moment(endDate).isBefore(momentDate)
					) {
						dayBlock.push({
							activeAfterRentPeriod: true,
							rentId: rentData.id,
							rightstart: this.getStartRight(new Date())
						});
					}
				}
				return dayBlock;
			}
		},
		viewReservationDetails: function(reservationId, closed) {
			if (closed) {
				this.$refs.historyModal.getHistoryData(reservationId);
			} else {
				this.$refs.reservationModal.showReservation(reservationId);
			}
		},
		scroll: function(e) {
			var self = this;
			var monthWidth = 6200;
			var index = Math.floor(e.target.scrollLeft / monthWidth);
			self.scrolledMonth = index;
			self.scrolledMonthDescription = self.utils.getMonth(index);
		},
		getStartLeft: function(start) {
			return (
				100 -
				(
					(1440 -
						moment(start, 'YYYY-MM-DD HH:mm:ss').diff(
							moment(start, 'YYYY-MM-DD HH:mm:ss').startOf('day'),
							'minutes'
						)) /
					1440
				).toFixed(2) *
					100
			);
		},
		getStartRight: function(end) {
			return (
				(
					(1440 -
						moment(end, 'YYYY-MM-DD HH:mm:ss').diff(
							moment(end, 'YYYY-MM-DD HH:mm:ss').endOf('day'),
							'minutes'
						)) /
					1440
				).toFixed(2) *
					100 -
				100
			);
		},
		newUnitReservation(unit, day, month, daysInfo) {
			let startDate = moment(
				month.year + '-' + month.month + '-' + day,
				'YYYY-MM-DD'
			).format('YYYY-MM-DD');
			let endDate = moment(
				month.year + '-' + month.month + '-' + day,
				'YYYY-MM-DD'
			).format('YYYY-MM-DD');
			let startTime = '00:00';
			if (daysInfo && daysInfo.length) {
				var startTimeData = moment(
					daysInfo[daysInfo.length - 1].endDate
				).format('HH:mm');
				startTime = startTimeData;
			} else {
				startTime = this.getStartTime();
			}
			let endTime = '23:59';
			this.$refs.newReservationModal.openModalWithData(
				startDate,
				startTime,
				endDate,
				endTime,
				unit
			);
		},
		getStartTime() {
			const today = new Date();
			const todayMoment = moment(today).format('YYYY-MM-DD');
			const startHours =
				today.getHours() < 10 ? '0' + today.getHours() : today.getHours();
			const startTime =
				today.getMinutes() < 10 ? '0' + today.getMinutes() : today.getMinutes();
			return startHours + ':' + startTime;
		},
		newUser() {
			this.$refs.userModal.newUser();
		},
		showUnit(unitId) {
			this.unit.unitId = unitId;
			this.editUnit.showModal = true;
		},
		updateUnits() {
			this.getUnits();
		},
		newReservation(event, unitId, month, day) {
			let startTime = '';
			let endTime = '';
			let startDate = '';
			let endDate = '';
			let isToday = true;

			if (month) {
				startDate = moment(
					month.year + '-' + month.month + '-' + day,
					'YYYY-MM-DD'
				).format('YYYY-MM-DD');
				endDate = moment(
					month.year + '-' + month.month + '-' + day,
					'YYYY-MM-DD'
				).format('YYYY-MM-DD');
				isToday = this.checkDateIsToday(day, month.month, month.year);
			}

			if (event) {
				const elWidth = event.target.scrollWidth;
				const leftX = event.offsetX;
				const identifier = event.target.id;
				if (this.reservationList[identifier]) {
					for (var i = 0; i < this.reservationList[identifier].length; i++) {
						let reservation = this.reservationList[identifier][i];
						if (
							(reservation.left === 0 &&
								this.reservationList[identifier].length === 1) ||
							leftX > elWidth - (reservation.right / 100) * elWidth
						) {
							startTime = reservation.endtext;
						}

						if (
							(reservation.left === 0 &&
								this.reservationList[identifier].length === 1) ||
							leftX < (reservation.left / 100) * elWidth
						) {
							endTime = reservation.starttext;
						}
					}
				}
			}

			if (event && event.srcElement.className.indexOf('reservation') >= 0) {
				return false;
			}
			const today = new Date();
			const todayMoment = moment(today).format('YYYY-MM-DD');
			const todayEndTime = '23:59';
			let startDateReservation = startDate ? startDate : todayMoment;
			let endDateReservation = endDate ? endDate : todayMoment;
			let startTimeReservation = startTime
				? startTime
				: isToday
				? this.getStartTime()
				: '08:00';
			let endTimeReservation = endTime ? endTime : todayEndTime;
			this.$refs.newReservationModal.openModalWithData(
				startDateReservation,
				startTimeReservation,
				endDateReservation,
				endTimeReservation,
				unitId
			);
		},
		gotoDate(value) {
			if (value) {
				var filterDateData = value.split('-');
				var filterDate =
					parseInt(filterDateData[2]) +
					'' +
					parseInt(filterDateData[1]) +
					'' +
					parseInt(filterDateData[0]);

				this.$el
					.querySelector('.day_' + filterDate)
					.scrollIntoView({ block: 'center' });
			}
		},
		toggleLabels() {
			this.$el.querySelector('#units').classList.toggle('active');
			this.$el.querySelector('.showLabelsOff').classList.toggle('hidden');
			this.$el.querySelector('.showLabelsOn').classList.toggle('hidden');
		},
		copyReservation(reservation) {
			let diff = moment(reservation.endDate).diff(
				moment(reservation.startDate),
				'months'
			);
			let newEndDate = moment(reservation.endDate)
				.add(diff, 'months')
				.format('YYYY-MM-DD');

			this.$refs.newReservationModal.openModalWithData(
				reservation.endDate,
				reservation.endTime,
				newEndDate,
				reservation.endTime,
				reservation.unitId,
				reservation.user_id,
				reservation
			);
		}
	}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
$dayWidth: 200px;
$dayHeight: 60px;
$lightGray: #eee;
$radius: 0;

.calendarOverview {
	-webkit-transform: translate3d(0, 0, 0);
	margin: 0;
	.showLabelsOff,
	.showLabelsOn {
		&.hidden {
			display: none;
		}
	}
	.plannerContainer {
		position: relative;
	}
	.dates {
		height: $dayHeight + 10px;
		.dateTag {
			font-size: 20px;
			display: block;
			color: #adabab;
		}
	}
	.units {
		position: absolute;
		top: ($dayHeight + 10px) !important;
		z-index: 999;
		ul {
			background-color: rgb(250, 250, 250);
			li {
				border-right: solid 2px darken($lightGray, 15%);
			}
			li:not(:last-child) {
				//border-bottom: solid 1px darken($lightGray, 5%);
			}
		}
		.unitImg {
			max-width: 48px;
			float: right;
			margin-left: 10px;
			border-radius: 3px;
		}
	}
	.item {
		height: $dayHeight;
		display: block;
		font-size: 14px;
		cursor: pointer;
	}
	.daysScroller {
		overflow-x: scroll;
		overflow-y: hidden;
		-webkit-overflow-scrolling: touch;
		-webkit-transform: translate3d(0, 0, 0);
	}
	.daysScroller::-webkit-scrollbar {
		width: 5px;
		height: 15px;
	}

	.daysScroller::-webkit-scrollbar-track {
		background: #f1f1f1;
	}

	.daysScroller::-webkit-scrollbar-thumb {
		background: rgb(19, 19, 19);
		border-radius: 10px;
	}
	.daysContainer {
		width: 70000px;
	}
	.unitTimeline {
		display: flex;
		width: 100%;
		height: $dayHeight;
	}
	.month {
		display: inline-block;
		margin-left: 30px;
		overflow: hidden;
		position: relative;
		height: 30px;
		span {
			position: absolute;
		}
	}
	.monthSchedule {
		margin-left: 30px;
		height: $dayHeight;
		&:first-child {
			margin-left: 0;
		}
	}
	.day {
		width: $dayWidth;
		height: $dayHeight;
		display: inline-block;
		//background-color: #FFF;
		//border: solid 1px $lightGray;
		// box-shadow: inset 0 0 1px darken($lightGray, 25%);
		position: relative;

		&.header {
			//background-color: darken($lightGray, 5%);
			text-align: center;
			padding-top: 10px;
			height: 70px;
		}

		&:not(.header) {
			outline: solid 1px darken($lightGray, 1%);
			&:hover {
				background-color: #eee !important;
				cursor: cell;
			}
		}

		&.isToday {
			background-color: #404040;
			color: #fff;
		}

		&.activeAfterRentPeriod {
			background: repeating-linear-gradient(
				45deg,
				#a0aaed,
				#a0aaed 10px,
				#fff 10px,
				#fff 20px
			);
		}

		b {
			position: absolute;
			width: 100%;
			text-align: center;
			left: 0;
			top: 0;
			bottom: 0;
			line-height: 40px;
			cursor: pointer;

			&:hover {
				background-color: #eee;
			}
		}
		i {
			position: absolute;
			margin: 0 auto;
			top: 18px;
			left: 0;
			right: 0;
			height: 24px;
			background: #0f56a7cd;
			text-shadow: 0 1px 0 rgb(0, 0, 0);
			//opacity: 0.5;
			cursor: pointer;
			z-index: 3;
			&.start {
				border-top-left-radius: $radius;
				border-bottom-left-radius: $radius;
			}
			&.end {
				border-top-right-radius: $radius;
				border-bottom-right-radius: $radius;
			}
			&.active {
				color: white;
			}
			&:hover {
				// opacity: 0.8;
				outline: solid 1px #666;
			}
			&:before {
				position: absolute;
				top: 0px;
				left: 5px;
				content: attr(data-starttext);
				font-style: normal;
				font-size: 10px;
				color: rgb(255, 255, 255);
				// background-color: #000;
				z-index: 99;
			}
			&:after {
				position: absolute;
				bottom: 0px;
				right: 5px;
				content: attr(data-endtext);
				font-style: normal;
				font-size: 10px;
				color: rgb(255, 255, 255);
				// background-color: #000;
				z-index: 99;
			}

			&.orange-tp {
				background-color: rgba(255, 96, 0, 0.74);
			}

			&.green-tp {
				background-color: rgba(21, 96, 44, 0.7);
				text-shadow: 0 1px 0 rgb(11, 41, 20);

				&:after,
				&:before {
					color: rgb(198, 235, 193);
				}
			}

			&.closed {
				background-color: rgba(157, 157, 157, 0.66);
				text-shadow: 0 1px 0 rgb(215, 215, 215);
				&:after,
				&:before {
					color: rgb(0, 0, 0);
				}
			}
		}

		#elapsedIndicator {
			position: absolute;
			border-right: dashed 1px #c1c1c1;
			width: 1px;
			height: 90vh;
			z-index: 3;
			top: $dayHeight + 10px;
		}
	}
	.calenderUnit,
	.day {
		padding: 10px;
	}
	.calenderUnit {
		color: rgb(92, 92, 92);
		font-size: 16px;
		//font-weight: bold;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
		//background-color: #EEE;
		line-height: 14px;
		text-align: right;
		small {
			font-weight: normal;
			color: #969696;
		}
	}
}
@media only screen and (max-width: 700px) {
	.units {
		ul {
			padding-left: 0;
			// background: linear-gradient(to right, rgba(255,255,255,1) 0%,rgba(255,255,255,1) 69%,rgba(255,255,255,0) 100%);
		}
		//display: none;
		pointer-events: none;

		// position: absolute;
		// top:104px;
		// left: 0;
		// z-index: 98;
		.calenderUnit {
			font-size: 10px !important;
			padding: 15px 5px 0 0;
		}
	}

	.day {
		max-width: 100px;
		font-size: 10px;
		overflow: hidden;
		white-space: nowrap;
	}
}
@media only screen and (min-width: 1800px) {
	.units {
		min-width: 240px;
	}
}
::-webkit-scrollbar {
	height: 32px;
}
</style>



// WEBPACK FOOTER //
// src/components/Planner/Planner.vue